import { render, staticRenderFns } from "./InstaPost.vue?vue&type=template&id=64d3d204&"
import script from "./InstaPost.vue?vue&type=script&lang=js&"
export * from "./InstaPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports